export const FLASH_SALE = { active: false, percent: 0.15, label: 'Flash Sale 15% Off' };

const EXCLUDED_CATEGORIES = ['Bundles', 'Nasal Kits'];

export const isDiscountEligible = (item) =>
  !EXCLUDED_CATEGORIES.includes(item.category) &&
  !/bac/i.test(item.name || '') &&
  !/kit/i.test(item.name || '');
